module.exports = __webpack_public_path__ + "static/media/about2.019d6aab.avif";